<template>
  <div>
    <div class="accordion mb-4">
      <div class="card card-box card-accordion">
        <div class="card-header">
          <b-button
            v-b-toggle="'accordion-' + accordionId"
            class="btn-accordion btn-link btn-lg d-flex align-items-center justify-content-between shadow-none p-3"
          >
            <span class="h5 font-weight-bold mb-0">{{ title }}</span>
            <font-awesome-icon icon="angle-up" class="font-size-xl" />
          </b-button>
        </div>
      </div>
    </div>
    <b-collapse :id="'accordion-' + accordionId">
      <slot></slot>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'BaseAccordions',

  props: {
    accordionId: {
      type: [Number, String],
      required: true
    },

    title: {
      type: String,
      default: ''
    }
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.card-accordion {
  border-radius: 10.4px !important;

  .btn-accordion {
    background: white !important;
    border-bottom-color: rgba(122, 123, 151, 0.3) !important;
  }
}
</style>
